import React from 'react'

const renderMaterials = (
  productComponent,
  productModel,
  handleMaterialUpdate,
  handleToggleComponent,
) => {
  // productComponent can be a full product or a cross-sell product
  // the materialData contains all the options for this product
  //console.log('productComponent', productComponent)
  // productModel is an assembled product model
  // the materialDatas of the productModel and the cross sells are the selected material options
  //console.log('productModel', productModel)

  const materialData = Array.isArray(productComponent.materialData)
    ? productComponent.materialData.flat()
    : productComponent.materialData

  const materialsByType = materialData.reduce((acc, material) => {
    ;(acc[material.type] = acc[material.type] || []).push(material)
    return acc
  }, {})

  const materialTypes = Object.keys(materialsByType)
  let selectedMaterials = []

  if (productComponent.modelCode === productModel.modelCode) {
    //console.log('top level, we chill')
    selectedMaterials = productModel.materialData
  } else {
    //console.log("dude where's my cross sell: ", productComponent.modelCode)
    const siblingModel = productModel.crossSellData.find(
      (crossSell) => crossSell.modelCode === productComponent.modelCode,
    )
    if (siblingModel) {
      //console.log('found sibling model', siblingModel)
      selectedMaterials = siblingModel.materialData
    }
  }

  const modelComponentNeedsToggle = (modelCode, componentCode) => {
    return [
      'EXS55W_PILEXS55B',
      'EXS55W_PILEXS55S',
      'EXS55_PILEXS55B',
      'EXS55_PILEXS55S',
      'FOL55_PILFOL55B',
      'FOL55_PILFOL55S',
      'FOL77_PILFOL77B',
      'FOL77_PILFOL77S',
      'FOLF_PILFOLF',
      'FOLR_PILFOLR',
      'OST43CH_PILOST47',
      'OST47_PILOST47',
      'OST77_PILOST47',
      'OZN195T_PILOZN195T',
      'OZN43T_PILOZN43T',
      'OZN47T_PILOZN47T',
      'OZN55T_PILOZN55T',
      'JIV55_PILJIV55AL',
      'JIV55W_PILJIV55AWL',
      'JIV55T_PILJIV55AL',
      'JIV55WT_PILJIV55AL',
      'JIV55WG_PILJIV55B',
      'JIV55WG_PILJIV55S',
      'JIV77WG_PILJIV77B',
      'JIV77WG_PILJIV77S',
      'NNX154T_PILNNX154T',
      'NNX43T_PILNNX55T',
      'NNX55T_PILNNX55T',
      'NNX60T_PILNNX60T',
      'NNX77T_PILNNX77T',
      'STY43CH_PILSTY55S',
      'STY43CH_PILSTY55B',
      'STY55_PILSTY55S',
      'STY55_PILSTY55B',
      'ZNT195_PILZNT195',
      'ZNT55_PILZNT55',
      'STP195UPH_PILSTP195UPH',
      'STP195UPH_PILSTP195',
      // 'STP195UPHTEST_PILSTP195UPHTEST',
      'STP195UPHTEST_PILSTP195TEST',
    ].includes(`${modelCode}_${componentCode}`)
  }

  const handleComponentToggle = (e) => {
    const parent = e.target.closest('div')
    const componentCode = e.target.getAttribute('data-component')

    if (!e.target.checked) {
      parent.classList.remove('checked')
      handleToggleComponent(componentCode, false)
    } else {
      parent.classList.add('checked')
      handleToggleComponent(componentCode, true)
    }
  }

  return (
    <div key={productComponent.modelCode} className="component-data checked">
      <h1 className="product-segment-title">
        {productComponent.modelCode}
        {modelComponentNeedsToggle(
          productModel.modelCode,
          productComponent.modelCode,
        ) && (
          <input
            type="checkbox"
            role="switch"
            data-component={productComponent.modelCode}
            onClick={handleComponentToggle}
            defaultChecked
          />
        )}
      </h1>
      {materialTypes.length > 0 &&
      materialTypes.some((type) => materialsByType[type].length > 1)
        ? materialTypes.map(
            (type) =>
              materialsByType[type].length > 1 && (
                <div key={`${type}_${productComponent.modelCode}`}>
                  <p>
                    Choose the {type} for the {productComponent.modelCode}:
                  </p>
                  <div className="button-list">
                    {materialsByType[type].map((material) => (
                      <button
                        data-key={`${productComponent.modelCode}_${type}_${material.code}`}
                        key={`${material.id}_${productComponent.modelCode}`}
                        className={
                          selectedMaterials.some(
                            (selectedMaterial) =>
                              selectedMaterial.material.materialId ===
                              material.id,
                          )
                            ? 'small selected'
                            : 'small'
                        }
                        onClick={() =>
                          handleMaterialUpdate(
                            event,
                            type,
                            material,
                            productComponent.modelCode,
                          )
                        }
                      >
                        {material.label ? material.label : material.code}
                      </button>
                    ))}
                  </div>
                </div>
              ),
          )
        : null}
    </div>
  )
}

export const renderMaterialOptions = (
  fullProduct,
  selectedProductVariants,
  handleMaterialUpdate,
  handleToggleComponent,
) => {
  if (selectedProductVariants.length === 0) {
    return null
  }

  const selectedVariant = selectedProductVariants.find(
    (variant) => variant.modelCode === fullProduct.modelCode,
  )

  if (!selectedVariant) {
    return null
  }

  return (
    <div>
      {
        // first rendering the main product
        renderMaterials(
          fullProduct,
          selectedVariant,
          handleMaterialUpdate,
          handleToggleComponent,
        )
      }

      {
        // if there are cross-sell products, render them as well
        fullProduct.crossSellData &&
          fullProduct.crossSellData.map((crossSellProduct) => {
            // console.log('selectedProductVariants', selectedProductVariants)
            const crossSellVariant = selectedProductVariants.find((variant) =>
              variant.crossSellData.some(
                (crossSell) =>
                  crossSell.modelCode === crossSellProduct.modelCode,
              ),
            )

            return crossSellVariant ? (
              <div key={crossSellProduct.modelCode}>
                {renderMaterials(
                  crossSellProduct,
                  crossSellVariant,
                  handleMaterialUpdate,
                  handleToggleComponent,
                )}
              </div>
            ) : (
              <div key={crossSellProduct.modelCode}>
                <p>No variant found for {crossSellProduct.modelCode}</p>
              </div>
            )
          })
      }
    </div>
  )
}
